import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { catchError } from 'rxjs/operators';

/**
 * Provide all navigation and redirection utilities
 *
 * @export
 * @class RedirectionUtilityLib
 */
@Injectable()
export class RedirectionUtilityLib {
  redirectUrl?: string;

  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
  ) {}

  navigate(url: string[]) {
    this.router.navigate(url);
  }

  /**
   *  This method is used for set the redirect url
   */
  setRedirectUrl(url: string): void {
    this.redirectUrl = url;
    this.router.navigate([], { relativeTo: this.route, queryParamsHandling: 'merge', queryParams: { redirectUrl: url } });
  }

  /**
   *  This method is used for get the redirect url
   */
  getRedirectUrl(returnUrl: (url?: string) => void): void {
    this.route.queryParams
      .pipe(
        catchError(() => {
          returnUrl();
          return [];
        }),
      )
      .subscribe((params) => {
        if (params['redirectUrl']) {
          this.redirectUrl = params['redirectUrl'];
        }
        returnUrl(this.redirectUrl);
      })
      .unsubscribe();
  }
}
